export const GetAllLogCustomTasks = () => {
  return $.get('LogTemplate/GetAllLogTasks?IsCustom=true&IsActive=true')
}

export const AddAndUpdateLogCustomTasks = (model) => {
  return $.ajax({
    url: 'LogTemplate/UpdateCustomLogMaintenanceList',   
    data: JSON.stringify(model),
    contentType: 'application/json',
    cache: false,
    type: 'POST'
  })
}

export const DeleteLogCustomTask = (Id) => {
  return $.post('LogTemplate/DeleteLogMaintenance?Id=' + Id)
}


// WEBPACK FOOTER //
// ./src/components/CustomTasks/custom_tasks.service.js